export const Wifi = (props) => {
  const { size = 24, onClick, verticalAlign, marginLeft, marginRight, top, color, className = ' ' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg xmlns='http://www.w3.org/2000/svg' style={{ verticalAlign }} width={size} height={size} fill='none' viewBox='0 0 24 24'>
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
          d='M21.5 8.955L12 20 2.5 8.955M2.5 8.955a13.386 13.386 0 0119 0M12 9.928a8.479 8.479 0 00-6.274 2.778M12 9.928a8.479 8.479 0 016.274 2.778M12 15.072a3.402 3.402 0 00-2.872 1.589M12 15.072c1.209 0 2.265.636 2.872 1.589'
        ></path>
      </svg>
    </span>
  );
};
